
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Search, ArrowLeft } from "lucide-react";

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="space-y-2">
          <h1 className="text-9xl font-bold tracking-tighter text-primary">404</h1>
          <h2 className="text-2xl font-semibold tracking-tight">Page non trouvée</h2>
          <p className="text-muted-foreground">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>
        </div>

        <div className="w-full max-w-sm mx-auto h-[1px] bg-border" />

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Voici quelques suggestions pour vous aider :
          </p>
          <div className="flex flex-col gap-2 sm:flex-row sm:gap-4 justify-center">
            <Button asChild variant="default">
              <Link to="/" className="flex items-center gap-2">
                <Home className="h-4 w-4" />
                Retour à l'accueil
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/contact" className="flex items-center gap-2">
                <Search className="h-4 w-4" />
                Rechercher de l'aide
              </Link>
            </Button>
          </div>
          <Button
            variant="ghost"
            onClick={() => window.history.back()}
            className="flex items-center gap-2 mx-auto"
          >
            <ArrowLeft className="h-4 w-4" />
            Retourner à la page précédente
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
